export default __webpack_public_path__ + "static/media/vs.988e3e47.svg";